import styled from 'styled-components';

const ColumnFilterCell = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
`;

export default ColumnFilterCell;
